import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../data/eTrack/initialState.eTrack.data';
import {
  fetchEtrackQuote as fetchEtrackQuoteAPI,
  fetchServiceModal as fetchServiceModalAPI,
  fetchQuoteTypes as fetchQuoteTypesAPI,
  createQuote as createQuoteAPI,
  deleteQuote as deleteQuoteAPI,
  saveQuote as saveQuoteAPI,
  submitQuote as submitQuoteAPI,
  fetchQuoteDetails as fetchQuoteDetailsAPI,
  fetchQuoteDetailsForEmail as fetchQuoteDetailsForEmailAPI,
  fetchQuoteDetailsForCopyEmail as fetchQuoteDetailsForCopyEmailAPI,
  getJobComplete as getJobCompleteAPI,
  getExportResellerQuote as getExportResellerQuoteAPI,
  getExportClientQuote as getExportClientQuoteAPI,
  fetchSiteTypeData as fetchSiteTypeAPI,
  fetchMCNListForExternalUser as fetchMCNListForExternalUserAPI,
} from '../../apis/eTrackApi';
import { fetchSites as fetchSiteAsPI } from '../../apis/entitlementsAPI';
import {
  sendEmailNotification as sendEmailNotificationAPI,
  sendEmailCopyNotification as sendEmailCopyNotificationAPI,
} from '../../apis/emailApi';
import {
  ACTIONS_ENTITLEMENTS,
  ACTIONS_ETRACK,
} from '../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../services/common/asyncThunkWrapper';
import {
  CHECK_BOX_VALUE,
  ETRACK_DATA,
  handlePending,
  handleRejection,
} from '../../constants';

export const fetchEtrackSearchQuote = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_SEARCH,
  fetchEtrackQuoteAPI
);

export const fetchSites = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENTS.FETCH_SITES,
  fetchSiteAsPI
);

export const fetchServiceModal = createAsyncThunkWrapper(
  ACTIONS_ETRACK.SERVICE_MODAL,
  fetchServiceModalAPI
);

export const fetchQuoteTypes = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_TYPES,
  fetchQuoteTypesAPI
);

export const createNewQuote = createAsyncThunkWrapper(
  ACTIONS_ETRACK.CREATE_QUOTE,
  createQuoteAPI
);

export const quoteDelete = createAsyncThunkWrapper(
  ACTIONS_ETRACK.DELETE_QUOTE,
  deleteQuoteAPI
);

export const quoteSave = createAsyncThunkWrapper(
  ACTIONS_ETRACK.SAVE_QUOTE,
  saveQuoteAPI
);

export const quoteSubmit = createAsyncThunkWrapper(
  ACTIONS_ETRACK.SUBMIT_QUOTE,
  submitQuoteAPI
);

export const fetchQuoteDetails = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_DETAILS,
  fetchQuoteDetailsAPI
);

export const fetchEtrackSearchQuotePagination = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_SEARCH_PAGINATION,
  fetchEtrackQuoteAPI
);

export const sendEmailNotification = createAsyncThunkWrapper(
  ACTIONS_ETRACK.SEND_NOTIFICATION,
  sendEmailNotificationAPI
);

export const sendEmailCopyNotification = createAsyncThunkWrapper(
  ACTIONS_ETRACK.SEND_COPY_NOTIFICATION,
  sendEmailCopyNotificationAPI
);

export const fetchQuoteDetailsForEmail = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_DETAILS_FOR_EMAIL,
  fetchQuoteDetailsForEmailAPI
);

export const fetchQuoteDetailsForCopyEmail = createAsyncThunkWrapper(
  ACTIONS_ETRACK.QUOTE_DETAILS_FOR_COPY_EMAIL,
  fetchQuoteDetailsForCopyEmailAPI
);

export const getJobComplete = createAsyncThunkWrapper(
  ACTIONS_ETRACK.JOB_COMPLETE,
  getJobCompleteAPI
);

export const getExportResellerQuote = createAsyncThunkWrapper(
  ACTIONS_ETRACK.ExportResellerQuote,
  getExportResellerQuoteAPI
);

export const getExportClientQuote = createAsyncThunkWrapper(
  ACTIONS_ETRACK.ExportClientrQuote,
  getExportClientQuoteAPI
);

export const fetchSiteType = createAsyncThunkWrapper(
  ACTIONS_ETRACK.FETCH_SITE_TYPE,
  fetchSiteTypeAPI
);

export const fetchMCNListForExternalUser = createAsyncThunkWrapper(
  ACTIONS_ETRACK.FETCH_MCN_DETAILS_FOR_EXTERNAL_USER,
  fetchMCNListForExternalUserAPI
);

const eTrackQuoteSlice = createSlice({
  name: 'eTrackQuote',
  initialState,
  reducers: {
    setResetAllValues: () => initialState,
    resetValues: (state) => {
      state.eTrackSerailNumber = initialState.eTrackSerailNumber;
      state.siteNameContains = initialState.siteNameContains;
      state.orderNumber = initialState.orderNumber;
      state.quoteNumber = initialState.quoteNumber;
      state.eTrackCheckBox = initialState.eTrackCheckBox;
      state.eTrachItems = initialState.eTrachItems;
      state.eTrackSiteID = initialState.eTrackSiteID;
      state.eTrackSiteName = initialState.eTrackSiteName;
      state.etrack = initialState.etrack;
      state.etrackAGridData = initialState.etrackAGridData;
      state.etrackBGridData = initialState.etrackBGridData;
      state.isEtrackLoading = initialState.isEtrackLoading;
      state.etrackDataFoundCount = initialState.etrackDataFoundCount;
      state.etrackDataFound = initialState.etrackDataFound;
      state.checkboxState = initialState.checkboxState;
      state.checkboxQuoteState = initialState.checkboxQuoteState;
      state.selectedData = initialState.selectedData;
      state.quoteFormData = initialState.quoteFormData;
      state.submitQuoteCommentText = initialState.submitQuoteCommentText;
      state.apiSuccessResponse = initialState.apiSuccessResponse;
      state.eTrackServiceID = initialState.eTrackServiceID;
      state.eTrackServiceName = initialState.eTrackServiceName;
      state.updateQuoteItemData = initialState.updateQuoteItemData;
      state.siteData = initialState.siteData;
      state.selectedeTrackQuoteType = initialState.selectedeTrackQuoteType;
      state.quoteDetails = initialState.quoteDetails;
      state.checkedForAdd = initialState.checkedForAdd;
      state.siteSyncNoSiteSelectedFlag = initialState.siteSyncNoSiteSelectedFlag;
    },
    fetchSerialNumber: (state, action) => {
      state.eTrackSerailNumber = action?.payload;
    },
    fetchSiteNameContains: (state, action) => {
      state.siteNameContains = action?.payload;
    },
    fetchOrderNumber: (state, action) => {
      state.orderNumber = action?.payload;
    },
    fetchQuoteNumber: (state, action) => {
      state.quoteNumber = action?.payload;
    },
    setOpenSiteModal: (state, action) => {
      state.siteNameModal.openSiteModal = action?.payload;
    },
    setOpenServiceModal: (state, action) => {
      state.serviceNameModal.openServiceModal = action?.payload;
    },
    setCheckBox: (state, action) => {
      state.eTrackCheckBox = action?.payload
        ? CHECK_BOX_VALUE.yes
        : CHECK_BOX_VALUE.no;
    },
    setETrachItems: (state, action) => {
      state.eTrachItems = action?.payload;
    },
    setSiteFormFeilds: (state, action) => {
      state.siteNameModal.siteSearchForm[action?.payload?.name] =
        action?.payload?.value;
    },
    setQuickEtrackCustomerNumber: (state, action) => {
      state.quickEtrackCustomerNumber = action?.payload;
    },
    setQuickEtrackCustomerName: (state, action) => {
      state.quickEtrackCustomerName = action?.payload;
    },
    setQuickEtrackCustomerId: (state) => {
      state.quickEtrackCustomerId = action?.payload;
    },
    setCustomerId: (state, action) => {
      state.customerId = Number(action?.payload);
    },
    handleCustomerIdExistingQuotes: (state, action) => {
      state.custIdExistingQuotes = Number(action?.payload);
    },
    handleCustomerNameExistingQuotes: (state, action) => {
      state.custNameExistingQuotes = action?.payload;
    },
    customerETrackExistingQuotes: (state, action) => {
      state.isCustomerETrackExistingQuote = action?.payload;
    },
    setSelectedSiteGridRowsData: (state, action) => {
      state.siteNameModal.gridSiteRowSelectedData =
        action?.payload?.length > 0 ? action?.payload : ETRACK_DATA.ANY;
      state.siteNameModal.gridSiteRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.eTrackSiteName = action?.payload[0]?.name
        ? action?.payload[0].name
        : '';
      state.eTrackSiteID = action?.payload[0]?.id ? action?.payload[0].id : 0;
      state.siteNameModal.openSiteModal = false;
    },
    udpatingMainEtrackGridData: (state, action) => {
      state.etrackAGridData = [];
      state.etrackAGridData = action?.payload || [];
    },
    settingCheckboxState: (state, action) => {
      state.checkboxState = action?.payload || initialState.checkboxState;
    },
    settingCheckboxArray: (state, action) => {
      state.checkboxArray[action?.payload?.currentPage] =
        action?.payload?.checkboxState;
    },
    settingCheckboxQuoteState: (state, action) => {
      state.checkboxQuoteState =
        action?.payload || initialState.checkboxQuoteState;
    },
    settingSelectedData: (state, action) => {
      state.selectedData = action?.payload || [];
    },
    setSelectedServiceGridRowsData: (state, action) => {
      state.serviceNameModal.gridServiceModalRowSelectedData =
        action?.payload?.length > 0 ? action?.payload : ETRACK_DATA.ANY;
      state.serviceNameModal.gridServiceModalRowSelectedCount =
        action?.payload?.length > 0 ? action?.payload?.length : 0;
      state.serviceNameModal.openServiceModal = false;

      state.eTrackServiceID = action?.payload[0]?.erpModelId
        ? action?.payload[0].erpModelId
        : 0;
      state.eTrackServiceName = action?.payload[0]?.name
        ? action?.payload[0].name
        : '';
    },
    setServiceFormFeilds: (state, action) => {
      state.serviceNameModal.serviceMpdalSearchForm[action?.payload?.name] =
        action?.payload?.value;
    },
    handleETrackQuoteType: (state, action) => {
      state.selectedeTrackQuoteType =
        action?.payload?.value || ETRACK_DATA.defaultETrackQuoteType;
    },
    handleAlertBoxOpen: (state, action) => {
      state.alertBoxOpen = action?.payload || false;
    },
    handleAlertBoxOpenAddItemModal: (state, action) => {
      state.alertBoxOpenAddItemModal = action?.payload || false;
    },
    handleAlertText: (state, action) => {
      state.alertText = action?.payload || ETRACK_DATA.alertTextMessage;
    },
    handleDialogAction: (state, action) => {
      state.dialogAction = action?.payload;
    },
    handleCreateQuoteFlag: (state, action) => {
      state.isCreateQuoteSuccess = action?.payload || false;
    },
    handleDeleteQuoteFlag: (state, action) => {
      state.isDeleteQuoteSuccess = action?.payload || false;
    },
    handleSaveQuoteFlag: (state, action) => {
      state.isSaveQuoteSuccess = action?.payload || false;
    },
    handleSubmitQuoteFlag: (state, action) => {
      state.isSubmitQuoteSuccess = action?.payload || false;
    },
    handleAPIQuotesResponse: (state, action) => {
      state.apiQuotesResponse =
        action?.payload || initialState.apiQuotesResponse;
    },
    handleQuoteFormData: (state, action) => {
      if (action?.payload) {
        state.quoteFormData[action?.payload?.key] =
          action?.payload?.value || '';
      }
    },
    handleSubmitQuoteComment: (state, action) => {
      state.submitQuoteCommentText = action?.payload || '';
    },
    handleSubmitQuoteModal: (state, action) => {
      state.isSubmitQuoteModalOpen = action?.payload || false;
    },
    handleSetApprovalByHWE: (state, action) => {
      state.approvalByHWE = action?.payload || false;
    },
    forBackToSearchPayload: (state, action) => {
      state.backToSearchPayload = action?.payload
        ? action?.payload
        : initialState.backToSearchPayload;
    },
    siteName_ServiceName: (state, action) => {
      if (action?.payload) {
        state.eTrackServiceName = action?.payload?.eTrackServiceName;
        state.eTrackSiteName = action?.payload?.eTrackSiteName;
        state.eTrackSiteID = action?.payload?.siteId;
        state.eTrackServiceID = action?.payload?.serviceModelId;
      }
    },
    triggerSubmitted: (state, action) => {
      state.triggerSubmitted = action?.payload ? action?.payload : false;
    },
    triggerAutoApproved: (state, action) => {
      state.triggerAutoApproved = action?.payload ? action?.payload : false;
    },
    removeExportData: (state) => {
      state.exportResellerQuoteData = initialState.exportResellerQuoteData;
      state.exportClientQuoteData = initialState.exportClientQuoteData;
      state.exportClientLoading = initialState.exportClientLoading;
      state.exportResellerLoading = initialState.exportResellerLoading;
    },
    updateETrackOrigin: (state, action) => {
      state.eTrackOrigin = action?.payload || '';
    },
    handleAddItemsModalOpen: (state, action) => {
      state.addItemsModalOpen = action?.payload || false;
    },
    setSelectedGridData: (state, action) => {
      state.selectedQuoteDetailGridData = action?.payload || [];
    },
    handleAlertBoxOpenQuoteDetail: (state, action) => {
      state.alertBoxOpenQuoteDetail = action?.payload || false;
    },
    handleAlertBoxTextQuoteDetail: (state, action) => {
      state.alertTextQuoteDetail = action?.payload || '';
    },
    updateQuoteItemData: (state, action) => {
      if (action?.payload) {
        state.updateQuoteItemData[action?.payload?.key] =
          action?.payload?.value;
      } else {
        state.updateQuoteItemData = initialState.updateQuoteItemData;
        state.siteData = initialState.siteData;
      }
    },
    setSiteData: (state, action) => {
      state.siteData[action?.payload?.key] = action?.payload?.value;
    },
    resetUpdateQuoteData: (state) => {
      state.updateQuoteItemData = initialState.updateQuoteItemData;
      state.siteData = initialState.siteData;
    },
    handleSiteSyncFlag: (state, action) => {
      state.siteSyncFlag = action?.payload;
    },
    isQuoteSearchGridDataChange: (state, action) => {
      state.isQuoteGridDataChange = action?.payload || initialState.isQuoteGridDataChange;
    },
    handleETrackSearchPage: (state, action) => {
      state.eTrackSearchPage = action?.payload || 0;
    },
    setisResetClicked: (state, action) => {
      state.isResetClicked = action?.payload;
    },
    setDataAndSelection: (state) => {
      state.etrackDataFoundCount = 0;
      state.selectedData = [];
      state.etrackDataFound = false;
      state.isSubmitLoading = initialState.isSubmitLoading;
      state.notificationSentLoading = initialState.notificationSentLoading;
      state.quoteDetailsForEmailLoading = initialState.quoteDetailsForEmailLoading;
      state.isOnlySubmit = initialState.isOnlySubmit;
      state.isSubmitApproveComplete = initialState.isSubmitApproveComplete;
      state.isSubmitApprove = initialState.isSubmitApprove;
      state.notificationSent = initialState.notificationSent;
      state.siteSyncNoSiteSelectedFlag = initialState.siteSyncNoSiteSelectedFlag;
    },
    setEtrackDataFound: (state) =>{
      state.etrackDataFound = initialState.etrackDataFound;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action?.payload;
    },
    setQuoteDetailsEmailData: (state, action) => {
      state.quoteDetailsForEmail = initialState.quoteDetailsForEmail;      
    },
    setNotificationSendFlag: (state, action) => {
      state.notificationSent = action?.payload;
    },
    setEosModelName: (state, action) => {
      state.eosModelName = action?.payload;
    },
    setEosDate: (state, action) => {
      state.eosDate = action?.payload;
    },
    handleIsMultipleSitesSiteSync: (state, action) => {
      state.isMultipleSitesSiteSync = action?.payload;
    },
    handleIsNewWarrantyEndDateEmpty: (state, action) => {
      state.isNewWarrantyEndDateEmpty = action?.payload;
    },
    resetCreatedData: (state) => {
      state.createQuoteData = initialState.createQuoteData;
      state.isCreateQuoteSuccess = initialState.isCreateQuoteSuccess;
    },
    handleCheckedForAdd: (state, action) => {
      state.checkedForAdd = action?.payload || null;
    },
    resetCopyEmailStates: (state) => {
      state.notificationSentCopy = initialState.notificationSentCopy;
    },
    handleResetQuoteItemExist: (state) => {
      state.quoteItemExist = false;
    },
    handleSiteSyncNoSiteSelectedFlag: (state, action) => {
      state.siteSyncNoSiteSelectedFlag = action?.payload || initialState.siteSyncNoSiteSelectedFlag;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEtrackSearchQuote.pending, (state, action) => {
        handlePending(state, action);
        state.etrack = [];
        state.etrackAGridData = [];
        state.etrackDataFound = false;
        state.etrackDataFoundCount = 0;
        state.isEtrackLoading = true;
        state.apiSuccessResponse = initialState.apiSuccessResponse;
      })
      .addCase(fetchEtrackSearchQuote.fulfilled, (state, action) => {
        if (action?.payload !== null) {
          state.etrack = [];
          state.etrackAGridData = [];
          let selectedEntitlements = [];
          if (state.selectedData?.length > 0) {
            state.selectedData?.map((selectedItem) => {
              selectedItem?.siteEntitlementList?.map((item) => {
                selectedEntitlements?.push(item?.entitlementId);
              });
            });
          }

          const mainGridNewData = action?.payload?.etrack
            ?.map((items) => {
              const filteredList = items.siteEntitlementList.filter(
                (entitlement) => {
                  const selectedItems = selectedEntitlements.every((item) => {
                    if (item !== entitlement?.entitlementId) {
                      return items;
                    }
                  });

                  return selectedItems;
                }
              );

              if (filteredList.length > 0) {
                return { ...items, siteEntitlementList: filteredList };
              } else {
                return action?.payload?.etrack[0];
              }
            })
            .filter(Boolean);
          state.etrack = mainGridNewData;
          state.etrackAGridData = mainGridNewData;
          state.etrackDataFound = true;
          state.etrackDataFoundCount = action?.payload?.totalRecords;
          state.isEtrackLoading = false;
        } else {
          state.etrack = [];
          state.etrackAGridData = [];
          state.etrackDataFound = true;
          state.etrackDataFoundCount = 0;
          state.isEtrackLoading = false;
          state.apiSuccessResponse.get = 'error';
        }
      })
      .addCase(fetchEtrackSearchQuote.rejected, (state, action) => {
        handleRejection(state, action);
        state.etrack = [];
        state.etrackAGridData = [];
        state.etrackDataFound = false;
        state.etrackDataFoundCount = 0;
        state.isEtrackLoading = false;
        state.apiSuccessResponse.get = 'error';
      })

      .addCase(fetchSites.pending, (state, action) => {
        handlePending(state, action);
        state.siteNameModal.loading = true;
        state.siteNameModal.siteSearchData = [];
        state.isSitesResultsFound = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.siteNameModal.loading = false;
        state.siteNameModal.sites = action?.payload;
        state.siteNameModal.siteSearchData = action?.payload || [];
        state.siteNameModal.siteGridTotalRecords = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.isSitesResultsFound = action?.payload
          ? action?.payload?.length > 0
          : false;
      })
      .addCase(fetchSites.rejected, (state, action) => {
        handleRejection(state, action);
        state.siteNameModal.loading = false;
        state.siteNameModal.siteSearchData = [];
        state.siteNameModal.siteGridTotalRecords = 0;
        state.isSitesResultsFound = true;
      })

      .addCase(fetchServiceModal.pending, (state, action) => {
        handlePending(state, action);
        state.serviceNameModal.loading = true;
        state.serviceNameModal.serviceModalSearchData = [];
        state.isServiceModalResultsFound = true;
      })
      .addCase(fetchServiceModal.fulfilled, (state, action) => {
        state.serviceNameModal.loading = false;
        state.serviceNameModal.serviceModal = action?.payload?.serviceModels;
        state.serviceNameModal.serviceModalSearchData =
          action?.payload?.serviceModels || [];
        state.serviceNameModal.serviceModalGridTotalRecords =
          action?.payload?.totalRecords;
        state.isServiceModalResultsFound = false;
      })
      .addCase(fetchServiceModal.rejected, (state, action) => {
        handleRejection(state, action);
        state.serviceNameModal.loading = false;
        state.serviceNameModal.serviceModalSearchData = [];
        state.serviceNameModal.serviceModalGridTotalRecords = 0;
        state.isServiceModalResultsFound = false;
      })

      .addCase(fetchQuoteTypes.pending, (state, action) => {
        handlePending(state, action);
        state.eTrackQuoteTypes = [];
      })
      .addCase(fetchQuoteTypes.fulfilled, (state, action) => {
        state.eTrackQuoteTypes =
          action?.payload?.filter(
            (item) =>
              item.id !== ETRACK_DATA.removedQuoteTypeId &&
              item.id !== ETRACK_DATA.removedQuoteTypeId1
          ) || [];
      })
      .addCase(fetchQuoteTypes.rejected, (state, action) => {
        handleRejection(state, action);
        state.eTrackQuoteTypes = [];
      })

      .addCase(createNewQuote.pending, (state, action) => {
        handlePending(state, action);
        state.isCreateNewQuoteLoading = true;
        state.isCreateQuoteSuccess = false;
        state.eosDate = null;
        state.eosModelName = null;
        state.quoteItemExist = null;
      })
      .addCase(createNewQuote.fulfilled, (state, action) => {
        state.isCreateNewQuoteLoading = false;
        state.createQuoteData = action?.payload || [];
        state.isCreateQuoteSuccess = true;
        state.eosDate = null;
        state.eosModelName = null;
      })
      .addCase(createNewQuote.rejected, (state, action) => {
        handleRejection(state, action);
        if (action?.error?.message?.toLowerCase() === 'rejected') {
          if (action?.payload?.response?.data?.isExists === true) {
            if (
              action?.payload?.response?.data?.quoteID !== null &&
              action?.payload?.response?.data?.quoteID !== '' &&
              action?.payload?.response?.data?.quoteID !== undefined
            ) {
              state.quoteItemExist = true;
              state.existItemQuoteIds = action?.payload?.response?.data?.quoteID?.replace(',', ', ');
            }
          }
        }
        else {
          state.quoteItemExist = false;
          state.existItemQuoteIds = [];
        }
        state.isCreateNewQuoteLoading = false;
        state.isCreateQuoteSuccess = false;
        state.createQuoteData = [];
        state.eosDate = null;
        state.eosModelName = null;
      })

      .addCase(quoteDelete.pending, (state, action) => {
        handlePending(state, action);
        state.isDeleteQuoteSuccess = true;
        state.apiQuotesResponse.deleteQuote = false;
        state.isDeleteLoading = true;
      })
      .addCase(quoteDelete.fulfilled, (state, action) => {
        if (action?.payload) {
          state.isDeleteLoading = false;
          state.isDeleteQuoteSuccess = false;
          state.createQuoteData = [];
          state.isCreateQuoteSuccess = false;
          state.apiQuotesResponse.deleteQuote = 'success';
        }
      })
      .addCase(quoteDelete.rejected, (state, action) => {
        handleRejection(state, action);
        state.isDeleteLoading = false;
        state.isDeleteQuoteSuccess = false;
        state.apiQuotesResponse.deleteQuote = 'error';
      })

      .addCase(quoteSave.pending, (state, action) => {
        handlePending(state, action);
        state.isSaveQuoteSuccess = false;
        state.apiQuotesResponse.saveQuote = false;
        state.isSaveLoading = true;
      })
      .addCase(quoteSave.fulfilled, (state, action) => {
        if (action?.payload) {
          state.isSaveLoading = false;
          state.isSaveQuoteSuccess = true;
          state.apiQuotesResponse.saveQuote = 'success';
          state.quoteFormData.custRef = initialState.quoteFormData.custRef;
          state.quoteFormData.description =
            initialState.quoteFormData.description;
        }
      })
      .addCase(quoteSave.rejected, (state, action) => {
        handleRejection(state, action);
        state.isSaveLoading = false;
        state.isSaveQuoteSuccess = false;
        state.apiQuotesResponse.saveQuote = 'error';
      })

      .addCase(quoteSubmit.pending, (state, action) => {
        handlePending(state, action);
        state.isSubmitLoading = true;
        state.isSubmitQuoteSuccess = false;
        state.apiQuotesResponse.submitQuote = false;
      })
      .addCase(quoteSubmit.fulfilled, (state, action) => {
        if (action?.payload) {
          state.isSubmitLoading = false;
          state.isSubmitQuoteSuccess = true;
          state.apiQuotesResponse.submitQuote = 'success';
          state.submitQuoteCommentText = '';
        }
      })
      .addCase(quoteSubmit.rejected, (state, action) => {
        handleRejection(state, action);
        state.isSubmitLoading = false;
        state.isSubmitQuoteSuccess = false;
        state.apiQuotesResponse.submitQuote = 'error';
      })

      .addCase(fetchQuoteDetails.pending, handlePending)
      .addCase(fetchQuoteDetails.fulfilled, (state, action) => {
        state.quoteDetails = action?.payload || [];
        state.apiQuotesResponse = action?.payload || '';
      })
      .addCase(fetchQuoteDetails.rejected, handleRejection)

      .addCase(fetchEtrackSearchQuotePagination.pending, (state, action) => {
        handlePending(state, action);
        state.etrack = [];
        state.etrackAGridData = [];
        state.etrackDataFoundCount = 0;
        state.isEtrackLoadingPagination = true;
      })
      .addCase(fetchEtrackSearchQuotePagination.fulfilled, (state, action) => {
        state.etrack = action?.payload?.etrack;
        state.etrackAGridData = action?.payload?.etrack;
        state.etrackDataFoundCount = action?.payload?.totalRecords;
        state.isEtrackLoadingPagination = false;
      })
      .addCase(fetchEtrackSearchQuotePagination.rejected, (state, action) => {
        handleRejection(state, action);
        state.etrack = [];
        state.etrackAGridData = [];
        state.etrackDataFoundCount = 0;
        state.isEtrackLoadingPagination = false;
      })

      .addCase(sendEmailNotification.pending, (state, action) => {
        handlePending(state, action);
        state.notificationSent = null;
        state.notificationSentLoading = true;
      })
      .addCase(sendEmailNotification.fulfilled, (state) => {
        state.notificationSent = true;
        state.notificationSentLoading = false;
        state.quoteDetailsForEmail = initialState.quoteDetailsForEmail;
      })
      .addCase(sendEmailNotification.rejected, (state, action) => {
        handleRejection(state, action);
        state.notificationSent = false;
        state.notificationSentLoading = false;
      })
      .addCase(sendEmailCopyNotification.pending, (state, action) => {
        handlePending(state, action);
        state.notificationSentCopy = null;
        state.notificationSentLoadingCopy = true;
        state.sentCopiedResponse = '';
      })
      .addCase(sendEmailCopyNotification.fulfilled, (state, action) => {
        state.notificationSentCopy = true;
        state.notificationSentLoadingCopy = false;
        state.quoteDetailsForCopyEmail = initialState.quoteDetailsForCopyEmail;
        state.sentCopiedResponse = action?.meta?.requestStatus;
      })
      .addCase(sendEmailCopyNotification.rejected, (state, action) => {
        handleRejection(state, action);
        state.notificationSentCopy = false;
        state.notificationSentLoadingCopy = false;
        state.sentCopiedResponse = '';
      })
      // normal email details fetched
      .addCase(fetchQuoteDetailsForEmail.pending, (state, action) => {
        handlePending(state, action);
        state.quoteDetailsForEmail = [];
        state.notificationSent = null;
        state.quoteDetailsForEmailLoading = true;
      })
      .addCase(fetchQuoteDetailsForEmail.fulfilled, (state, action) => {
        state.quoteDetailsForEmail = action?.payload || [];
        state.quoteDetailsForEmailLoading = false;
      })
      .addCase(fetchQuoteDetailsForEmail.rejected, (state, action) => {
        handleRejection(state, action);
        state.quoteDetailsForEmail = [];
        state.quoteDetailsForEmailLoading = false;
      })
      //copy email details fetched
      .addCase(fetchQuoteDetailsForCopyEmail.pending, (state, action) => {
        handlePending(state, action);
        state.quoteDetailsForCopyEmail = [];
        state.notificationSentCopy = null;
        state.quoteDetailsForCopyEmailLoading = true;
      })
      .addCase(fetchQuoteDetailsForCopyEmail.fulfilled, (state, action) => {
        state.quoteDetailsForCopyEmail = action?.payload || [];
        state.quoteDetailsForCopyEmailLoading = false;
      })
      .addCase(fetchQuoteDetailsForCopyEmail.rejected, (state, action) => {
        handleRejection(state, action);
        state.quoteDetailsForCopyEmail = [];
        state.quoteDetailsForCopyEmailLoading = false;
      })

      .addCase(getJobComplete.pending, (state, action) => {
        handlePending(state, action);
        state.jobComplete = false;
      })
      .addCase(getJobComplete.fulfilled, (state) => {
        state.jobComplete = true;
      })
      .addCase(getJobComplete.rejected, (state, action) => {
        handleRejection(state, action);
        state.jobComplete = true;
      })

      .addCase(getExportResellerQuote.pending, (state, action) => {
        handlePending(state, action);
        state.exportResellerLoading = true;
        state.exportResellerQuoteData = [];
      })
      .addCase(getExportResellerQuote.fulfilled, (state, action) => {
        state.exportResellerLoading = false;
        state.exportResellerQuoteData = action?.payload || [];
      })
      .addCase(getExportResellerQuote.rejected, (state, action) => {
        handleRejection(state, action);
        state.exportResellerLoading = false;
        state.exportResellerQuoteData = [];
      })

      .addCase(getExportClientQuote.pending, (state, action) => {
        handlePending(state, action);
        state.exportClientLoading = true;
        state.exportClientQuoteData = [];
      })
      .addCase(getExportClientQuote.fulfilled, (state, action) => {
        state.exportClientLoading = false;
        state.exportClientQuoteData = action?.payload || [];
      })
      .addCase(getExportClientQuote.rejected, (state, action) => {
        handleRejection(state, action);
        state.exportClientLoading = false;
        state.exportClientQuoteData = [];
      })
      
      // Site Type
      .addCase(fetchSiteType.pending, (state) => {
        state.siteTypeData = [];
      })
      .addCase(fetchSiteType.fulfilled, (state, action) => {
        state.siteTypeData = action?.payload || [];
      })
      .addCase(fetchSiteType.rejected, (state) => {
        state.siteTypeData = [];
      })

      // Fetch MCN List for eTrack External User
      .addCase(fetchMCNListForExternalUser.pending, (state) => {
        state.listOfMCN = [];
      })
      .addCase(fetchMCNListForExternalUser.fulfilled, (state, action) => {
        state.listOfMCN = action?.payload || [];
        state.listOfMCNUpdated = true;
      })
      .addCase(fetchMCNListForExternalUser.rejected, (state) => {
        state.listOfMCN = [];
        state.listOfMCNUpdated = true;
      });
  },
});

export const {
  setResetAllValues,
  resetValues,
  fetchSerialNumber,
  fetchSiteNameContains,
  fetchOrderNumber,
  fetchQuoteNumber,
  setCheckBox,
  setETrachItems,
  setSelectedSiteGridRowsData,
  setOpenSiteModal,
  setSiteFormFeilds,
  setQuickEtrackCustomerNumber,
  setQuickEtrackCustomerName,
  setQuickEtrackCustomerId,
  udpatingMainEtrackGridData,
  settingCheckboxState,
  settingCheckboxArray,
  settingCheckboxQuoteState,
  settingSelectedData,
  setSelectedServiceGridRowsData,
  setServiceFormFeilds,
  setOpenServiceModal,
  //E-Track - Selected Quote Type
  handleETrackQuoteType,
  //Commonn - Alert Box Open / Close
  handleAlertBoxOpen,
  handleAlertBoxOpenAddItemModal,
  handleAlertText,
  handleDialogAction,
  handleCreateQuoteFlag,
  handleDeleteQuoteFlag,
  handleSaveQuoteFlag,
  handleSubmitQuoteFlag,
  handleAPIQuotesResponse,
  handleQuoteFormData,
  handleSubmitQuoteComment,
  handleSubmitQuoteModal,
  handleSetApprovalByHWE,
  forBackToSearchPayload,
  siteName_ServiceName,
  triggerSubmitted,
  triggerAutoApproved,
  removeExportData,
  updateETrackOrigin,
  handleAddItemsModalOpen,
  setSelectedGridData,
  handleAlertBoxOpenQuoteDetail,
  handleAlertBoxTextQuoteDetail,
  updateQuoteItemData,
  setSiteData,
  resetUpdateQuoteData,
  setCustomerId,
  handleCustomerIdExistingQuotes,
  handleCustomerNameExistingQuotes,
  customerETrackExistingQuotes,
  handleSiteSyncFlag,
  isQuoteSearchGridDataChange,
  handleETrackSearchPage,
  setisResetClicked,
  setDataAndSelection,
  setRowsPerPage,
  setQuoteDetailsEmailData,
  setNotificationSendFlag,
  setEosModelName,
  setEosDate,
  handleIsMultipleSitesSiteSync,
  handleIsNewWarrantyEndDateEmpty,
  resetCreatedData,
  handleCheckedForAdd,
  setEtrackDataFound,
  resetCopyEmailStates,
  handleResetQuoteItemExist,
  handleSiteSyncNoSiteSelectedFlag,
} = eTrackQuoteSlice.actions;
export default eTrackQuoteSlice.reducer;
